// extracted by mini-css-extract-plugin
var _1 = "DemoSignupModalButton__buttonFrameBackground--T50wR";
var _2 = "DemoSignupModalButton__buttonImage--gcnb5";
var _3 = "DemoSignupModalButton__buttonText--SiPnq CoreGeneral__roboto--UlmjE";
var _4 = "DemoSignupModalButton__buttonWrap--vqeYM";
export { _1 as "buttonFrameBackground", _2 as "buttonImage", _3 as "buttonText", _4 as "buttonWrap" }
